// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1y6mA","content":"styles_content__2tIvk","selectAll":"styles_selectAll__1jzJy"};